<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      d="M7.34864 0.857147H3.48213C3.36156 0.857147 3.30128 0.857147 3.24805 0.876667C3.20099 0.893928 3.15812 0.922099 3.12255 0.959141C3.08233 1.00103 3.05537 1.05836 3.00144 1.17303L0.179947 7.17303C0.0511797 7.44685 -0.0132043 7.58377 0.00226065 7.69506C0.0157647 7.79224 0.066321 7.87922 0.142032 7.93553C0.228738 8.00001 0.372704 8 0.660637 8H4.82945L2.81409 15.1429L11.0052 6.11094C11.2816 5.80622 11.4198 5.65386 11.4278 5.52349C11.4349 5.41033 11.3909 5.30035 11.3094 5.22717C11.2156 5.14286 11.0165 5.14286 10.6184 5.14286H5.83713L7.34864 0.857147Z"
      fill="currentColor"
    />
  </svg>
</template>
